module.exports = __webpack_public_path__ + "img/mc170.de8bbe91.jpg";